import React from 'react';
import { ClientSubscriptionViewModel } from '@common/model/billing/clientSubscription/view';
import { INACTIVE_SUBSCRIPTION_STATUSES } from '@common/model/client/subscriptionStatus';
import { clientBillingApi } from '../api';

type DataType =
  | undefined
  | { subscription: ClientSubscriptionViewModel; isStopped: boolean; canBeStopped: boolean; isPayedAndNotExpired: boolean };

/**
 * @deprecated
 * use useClientSubscription from @cp/entities/subscription
 */
export const useClientSubscription = (): {
  data: DataType;
  isLoading: boolean;
} => {
  const { data: subscription, isLoading } = clientBillingApi.endpoints.getBillingSubscription.useQuery();

  const data = React.useMemo<DataType>(() => {
    if (!subscription) {
      return undefined;
    }

    const isStopped = INACTIVE_SUBSCRIPTION_STATUSES.includes(subscription.status);
    const canBeStopped = !isStopped;
    const isPayedAndNotExpired = subscription.expiredAt ? new Date(subscription.expiredAt) > new Date() : false;

    const _data: DataType = { subscription, isStopped, canBeStopped, isPayedAndNotExpired };

    return _data;
  }, [subscription]);

  return {
    data,
    isLoading,
  };
};
